import { useMutation } from '@apollo/client';
import { UPDATE_USER_MUTATION } from '../Account/withUpdateUser';

export const useUpdateDbUserLocale = () => {
  const [saveUserLocale] = useMutation(UPDATE_USER_MUTATION);

  const updateDbUserLocale = async (
    userLocale: string,
    userLocaleOriginal: string,
  ) => {
    await saveUserLocale({
      variables: {
        userInput: { userLocale, userLocaleOriginal },
      },
    });
  };

  return { updateDbUserLocale };
};
